export const ExperienceData = [
    {
        designation: "Senior Web Application Developer",
        institution: "Khwaja Yunus Ali University",
        duration: "15-Sep-2024 – Currently Working – ",
        address: "Enayetpur, Chouhali, Sirajganj - 6751, Bangladesh"
    },
    {
        designation: "Teaching Assistant",
        institution: "Khwaja Yunus Ali University",
        duration: "2-Feb-2023 – Currently Working",
        address: "Enayetpur, Chouhali, Sirajganj - 6751, Bangladesh"
    },
    {
        designation: "Web Application Developer",
        institution: "Khwaja Yunus Ali Medical College & Hospital",
        duration: "02-Sep-2021 – Currently Working",
        address: "Enayetpur, Chouhali, Sirajganj - 6751, Bangladesh"
    },
    {
        designation: "Web Application Developer",
        institution: "Khwaja Yunus Ali University",
        duration: "3-Nov-2019 – 02-Sep-2021 (1.10 year)",
        address: "Enayetpur, Chouhali, Sirajganj - 6751, Bangladesh"
    },
    {
        designation: "Web Developer",
        institution: "Advance Technology Innovation Limited (ATI)",
        duration: "1 Sep 2018 – 1 Nov 2019 (1.02 year)",
        address: "ATI Center House # 1, Road # 9/A Sector # 7, Dhaka 1230."
    },
];